import React, { useCallback, useRef } from 'react';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import VietnameseFont1 from './item/vietnameseFont1.json';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
// eslint-disable-next-line
function ConfirmButton({ top, answerKey, answer, onConfirm }) {
  const loader = new FontLoader();
  const font = loader.parse(VietnameseFont1);
  const textRef = useRef();
  const planeMaterialRef = useRef();
  const planeRef = useRef();

  const geometry = new TextGeometry('Xác Nhận', {
    font: font,
    size: 10,
    height: 0.5,
    depth: 1,
    curveSegments: 4,
    bevelThickness: 1,
    bevelSize: 0,
    bevelEnabled: true,
  });
  geometry.computeBoundingBox();

  const onPointerEnter = useCallback(() => {
    document.body.style.cursor = 'pointer';
  }, []);

  const onPointerLeave = useCallback(() => {
    document.body.style.cursor = 'default';
  }, []);

  return (
    <group position={[0, -top / 2 - 20, 0]}>
      <mesh ref={textRef} position={[-28, -4.5, 0]}>
        <primitive object={geometry} />
        <meshBasicMaterial color={'white'} />
      </mesh>
      <mesh
        ref={planeRef}
        position={[0, 0, 0]}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        onClick={onConfirm}
      >
        <planeGeometry args={[100, 30]} />
        <meshBasicMaterial
          ref={planeMaterialRef}
          transparent
          alphaTest={0.5}
          color={`blue`}
        />
      </mesh>
    </group>
  );
}

export default ConfirmButton;
